import { useMemo } from 'react';
import { Tag, Typography } from 'antd';
import { SmartDataTableProps } from '@src/components/SmartDataTable/types';
import { useStatusRender } from './useStatusRender';
import { useUserTimestampRender } from '@src/hooks';
import { STATUS_FILTER_OPTIONS } from '../constants';
import dayjs from 'dayjs';

const { Text } = Typography;

export const useManufacturersColumns = (): SmartDataTableProps['columns'] => {
  const getStatusConfig = useStatusRender();
  const userTimestampRender = useUserTimestampRender({
    size: 'small',
  });

  return useMemo(
    () => [
      {
        key: 'id',
        title: 'ID',
        dataIndex: 'id',
        sorter: true,
        minWidth: 80,
        ellipsis: true,
        render: (value: any) => (
          <Text
            style={{
              fontSize: '12px',
              color: '#8c8c8c',
              backgroundColor: '#f5f5f5',
              padding: '2px 6px',
              borderRadius: '4px',
            }}
          >
            #{value}
          </Text>
        ),
      },

      // {
      //   key: 'manufacturer',
      //   title: 'Manufacturer',
      //   dataIndex: 'manufacturer',
      //   sorter: false,
      //   minWidth: 200,
      //   render: (manufacturer: any, record: any) => (
      //     <div>
      //       <div style={{ fontWeight: 500, color: '#262626' }}>
      //         {record.manufacturer || 'N/A'}
      //       </div>
      //     </div>
      //   ),
      // },
      {
        key: 'manufacturer_info',
        title: 'Supplier Info',
        dataIndex: 'manufacturer',
        sorter: false,
        minWidth: 200,
        render: (name: any, record: any) => (
          <div>
            <div style={{ fontWeight: 500, color: '#262626' }}>
              {record.contact_person || 'N/A'}
            </div>
            <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
              +{record.phone || 'No email'}
            </div>
          </div>
        ),
      },
      {
        key: 'user_timestamp',
        title: 'User & Timestamp',
        dataIndex: 'user_info',
        sorter: false,
        minWidth: 200,
        render: (value: any, record: any) => userTimestampRender(record),
      },
    ],
    [getStatusConfig, userTimestampRender]
  );
};
